import { AutomobileMaintenancePart } from '@/reports/types/vehicles';
import { Accordion, Text, Box, Table, Stack } from '@/theme/index';
import { commaFormatCurrency } from '@/utils/index';

interface MobileRepairQuotePartProps {
  part: AutomobileMaintenancePart;
}

export const MobileRepairQuotePart = ({ part }: MobileRepairQuotePartProps) => {
  const dataValues = [
    ['Category', part.category || '-'],
    ['Type', part.type || '-'],
    ['Quantity', part.quantity?.toString() || '-'],
    ['Price', (Boolean(part.price) && commaFormatCurrency(part.price)) || '-'],
  ];

  return (
    <Accordion
      data-cy="mobile-repair-quote-part-table"
      children={
        <Stack alignItems="flex-start">
          {<Table className="striped flipped" rows={dataValues} />}
        </Stack>
      }
      display={
        <Stack>
          <Box>
            <Text sx={{ color: 'black', fontWeight: 'bold' }}>
              {part.description || '-'}
            </Text>
          </Box>
        </Stack>
      }
    />
  );
};
